import React from 'react';

const icons = {
  user: (
    <>
      <circle cx="10" cy="6.5" r="3.1" />
      <path d="M10 11c-2.6 0-4.75 1.55-4.75 3.45V17h9.5v-2.55C14.75 12.55 12.6 11 10 11z" />
    </>
  ),
  students: (
    <>
      <path d="M10 2.5 17.25 6.25 10 10 2.75 6.25 10 2.5z" />
      <path d="M5.25 7v3.85c0 1.7 2.13 3 4.75 3s4.75-1.3 4.75-3V7l-4.75 2.15L5.25 7z" />
      <rect x="2.35" y="6.15" width="0.75" height="4.1" rx="0.35" />
      <circle cx="2.72" cy="11.05" r="0.95" />
    </>
  ),
  careers: (
    <>
      <path d="M10 2.75 17.25 7v1.1H2.75V7L10 2.75z" />
      <path d="M4.35 8.6h1.45v6.65H4.35zm3.3 0h1.45v6.65H7.65zm3.3 0h1.45v6.65H10.95zm3.3 0h1.45v6.65h-1.45z" />
      <path d="M2.75 15.75h14.5v1.5H2.75v-1.5z" />
    </>
  ),
  courses: (
    <>
      <path d="M10 4.25 4.5 6.5v8.75c1.55-.8 3.4-1.25 5.5-1.3V4.25z" />
      <path d="M10 4.25 15.5 6.5v8.75c-1.55-.8-3.4-1.25-5.5-1.3V4.25z" />
    </>
  ),
  exams: (
    <>
      <path d="M6.25 3.5h7.5A1.25 1.25 0 0 1 15 4.75V16a1.25 1.25 0 0 1-1.25 1.25H6.25A1.25 1.25 0 0 1 5 16V4.75A1.25 1.25 0 0 1 6.25 3.5z" />
      <path d="M8.1 2.5h3.8c.45 0 .85.35.85.8V4.5H7.25V3.3c0-.45.4-.8.85-.8z" />
      <rect x="7.35" y="7.1" width="5.3" height="1.35" rx="0.35" />
      <rect x="7.35" y="9.7" width="5.3" height="1.35" rx="0.35" />
      <rect x="7.35" y="12.3" width="3.6" height="1.35" rx="0.35" />
    </>
  ),
  periods: (
    <>
      <path d="M4 5.75h12c.9 0 1.65.75 1.65 1.65V16c0 .9-.75 1.65-1.65 1.65H4c-.9 0-1.65-.75-1.65-1.65V7.4C2.35 6.5 3.1 5.75 4 5.75z" />
      <rect x="6.1" y="2.9" width="1.8" height="3.35" rx="0.45" />
      <rect x="12.1" y="2.9" width="1.8" height="3.35" rx="0.45" />
      <rect x="3.35" y="8.35" width="13.3" height="1.35" />
      <circle cx="7.2" cy="11.85" r="0.95" />
      <circle cx="10" cy="11.85" r="0.95" />
      <circle cx="12.8" cy="11.85" r="0.95" />
      <circle cx="7.2" cy="14.55" r="0.95" />
      <circle cx="10" cy="14.55" r="0.95" />
    </>
  ),
  audit: (
    <path d="M10 2.75 16.1 5.45v5.05c0 3.05-2.55 5.35-6.1 5.95-3.55-.6-6.1-2.9-6.1-5.95V5.45L10 2.75z" />
  ),
};

export function SidebarIcon({ name }) {
  const glyph = icons[name];
  if (!glyph) {
    return null;
  }

  return (
    <svg
      className="sidebar-nav__icon"
      viewBox="0 0 20 20"
      width="20"
      height="20"
      aria-hidden="true"
      fill="currentColor"
    >
      {glyph}
    </svg>
  );
}
